import { inject, Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';
import { Ticket } from '../models/tickets.model';
import { DrawerRegistryService } from '../../../shared/services/drawer-registry.service';

/**
 * Opciones que el drawer acepta al abrirse.
 *
 * - ticketId definido → modo edit (carga el ticket por id).
 * - parentTicketId → modo "crear sub-ticket de este padre".
 * - contactId / companyId / dealId / pipelineId → prefills cuando se abre desde
 *   otro módulo (detalle de contacto/empresa/deal o desde un pipeline concreto).
 */
export interface TicketsDrawerOptions {
  ticketId?: number;
  parentTicketId?: number;
  contactId?: number;
  contactName?: string;
  companyId?: number;
  companyName?: string;
  dealId?: number;
  leadId?: number;        // Inc 25: lead de origen (se guarda en TicketRequest.idLead)
  leadName?: string;
  pipelineId?: number;
}

@Injectable({ providedIn: 'root' })
export class TicketsDrawerService {
  private readonly registry = inject(DrawerRegistryService);
  private readonly state$ = new BehaviorSubject<{ isOpen: boolean; options: TicketsDrawerOptions }>({
    isOpen: false,
    options: {}
  });

  private readonly ticketSaved$$ = new Subject<Ticket>();

  readonly state = this.state$.asObservable();
  readonly ticketSaved$ = this.ticketSaved$$.asObservable();

  open(options: TicketsDrawerOptions = {}): void {
    if (!this.state$.value.isOpen) this.registry.opened();
    this.state$.next({ isOpen: true, options });
  }

  close(): void {
    if (this.state$.value.isOpen) this.registry.closed();
    this.state$.next({ isOpen: false, options: {} });
  }

  notifySaved(ticket: Ticket): void {
    this.ticketSaved$$.next(ticket);
  }
}
